// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  min-width: 510px;
}
.container .sel-type {
  width: 400px;
}
.container .row-input {
  width: 400px;
}
.container .schedulig-list {
  max-height: 500px;
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/scripts/script-scheduling/script-scheduling.component.scss","webpack://./../../../../%E6%9D%AD%E5%B7%9E%E6%95%B0%E7%BA%B3%E5%B7%9D/IccpPlatform/fuxa/client/src/app/scripts/script-scheduling/script-scheduling.component.scss"],"names":[],"mappings":"AACA;EAEI,gBAAA;ACDJ;ADEI;EACI,YAAA;ACAR;ADEI;EACI,YAAA;ACAR;ADGI;EACI,iBAAA;EACA,cAAA;ACDR","sourcesContent":["\n.container {\n\n    min-width: 510px;\n    .sel-type {\n        width: 400px;\n    }\n    .row-input {\n        width: 400px;\n    }\n\n    .schedulig-list {\n        max-height: 500px;\n        overflow: auto;\n    }\n}",".container {\n  min-width: 510px;\n}\n.container .sel-type {\n  width: 400px;\n}\n.container .row-input {\n  width: 400px;\n}\n.container .schedulig-list {\n  max-height: 500px;\n  overflow: auto;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
